/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { LuisAppMigrationState } from 'src/clu/core/services/migration/cluMigrationSwaggers';
import { OmitFunctions } from 'src/core/stores/types';
import { ModelJobStates } from 'src/modules/modelTraining/types/trainingTypes';

type CluMigrationJobStoreData = OmitFunctions<Partial<Omit<CluMigrationJobStore, 'id'>>>;

export class CluMigrationJobStore {
    public id: string;

    @observable public luisAppsMigrationState: LuisAppMigrationState[];

    @observable public errors: string[];

    @observable public warnings: string[];

    @observable public status: ModelJobStates;

    constructor(id: string, data?: CluMigrationJobStoreData) {
        this.id = id;
        this.status = data?.status;
        this.luisAppsMigrationState = [...data.luisAppsMigrationState];
        this.errors = data?.errors ?? [];
        this.warnings = data.warnings ?? [];
    }

    @action
    public updateData(data: CluMigrationJobStoreData) {
        this.status = data.status;
        this.errors = data.errors;
        this.warnings = data.warnings;
        this.luisAppsMigrationState = [...data.luisAppsMigrationState];
    }

    @action
    public setStatus(status: ModelJobStates) {
        this.status = status;
    }
}
